import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BlockIcon from '@mui/icons-material/Block';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined'; // Report icon
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'; //- Regroup
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MapIcon from '@mui/icons-material/Map';
import ModeOfTravelIcon from '@mui/icons-material/ModeOfTravel';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import OutboxOutlinedIcon from '@mui/icons-material/OutboxOutlined'; // Send To OBC
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import RefreshIcon from '@mui/icons-material/Refresh';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import SplitScreen from '@mui/icons-material/Splitscreen';
import { Checkbox, IconButton, ListItem, ListItemIcon, ListItemText, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import CalculatorIcon from '../../../../shared/common-utilities/utils/CalculatorIcon';
import ChangeRoutesIcon from '../../../../shared/common-utilities/utils/ChangeRoutesIcon'; // ChangeRoutes
import ChangeStatusIcon from '../../../../shared/common-utilities/utils/ChangeStatusIcon'; // ChangeStatus
import DeleteTripIcon from '../../../../shared/common-utilities/utils/DeleteTripIcon'; // DeleteTrip
import FourCornerIcon from '../../../../shared/common-utilities/utils/FourCornerIcon.jsx';
import InsertActionIcon from '../../../../shared/common-utilities/utils/InsertActionIcon'; // Insert Begin/end Action
import MoveDownIcon from '../../../../shared/common-utilities/utils/MoveDownIcon'; // MoveDown
import MoveUpIcon from '../../../../shared/common-utilities/utils/MoveUpIcon'; // MoveUp
import ShipmentMoveBlIcon from '../../../../shared/common-utilities/utils/ShipmentMoveBlIcon'; // ShipmentMoveBl
import SplitTripIcon from '../../../../shared/common-utilities/utils/SplitTripIcon'; // Split Trip
import TransferGoodsIcon from '../../../../shared/common-utilities/utils/TransferGoodsIcon'; //  Transfer Goods
import getSetDataService from '../../services/getSetDataService';
import BatchTripCreationIcon from '../../utils/BatchTripCreationIcon';
import CardResourcesIcon from '../../utils/CardResourcesIcon';
import ChangePlanDepartmentIcon from '../../utils/ChangePlanDepartmentIcon';
import ChangePlanSubDepartmentIcon from '../../utils/ChangePlanSubDepartmentIcon';
import ChangesStatusTripIcon from '../../utils/ChangesStatusTripIcon';
import CreateBookingIcon from '../../utils/CreateBookingIcon';
import CreateEcmrIcon from '../../utils/CreateEcmrIcon';
import CreateExistingBookingIcon from '../../utils/CreateExistingBookingIcon';
import CreateTripIcon from '../../utils/CreateTripIcon';
import CustomHookoffIcon from '../../utils/CustomHookoffIcon';
import DeleteTerminalIcon from '../../utils/DeleteTerminalIcon';
import DepotDelIcon from '../../utils/DepotDelIcon';
import DepotIcon from '../../utils/DepotIcon';
import DrillDownTripIcon from '../../utils/DrillDownTripIcon';
import EmailConfirmationIcon from '../../utils/EmailConfirmationIcon';
import EmailTripIcon from '../../utils/EmailTripIcon';
import ExchangeTrailerIcon from '../../utils/ExchangeTrailerIcon';
import HookoffDelIcon from '../../utils/HookoffDelIcon';
import HookoffIcon from '../../utils/HookoffIcon';
import InsertExtraActionIcon from '../../utils/InsertExtraActionIcon';
import InsertShippinglineIcon from '../../utils/InsertShippinglineIcon';
import InsertTerminalIcon from '../../utils/InsertTerminalIcon';
import ManualModeIcon from '../../utils/ManualModeIcon.jsx';
import MoveLuIcon from '../../utils/MoveLuIcon';
import NewTrailerIcon from '../../utils/NewTrailerIcon';
import PartialTripIcon from '../../utils/PartialTripIcon';
import PrintCmrIcon from '../../utils/PrintCmrIcon';
import PrintOutsourceConfirmationIcon from '../../utils/PrintOutsourceConfirmationIcon';
import PrintTripSheetIcon from '../../utils/PrintTripSheetIcon';
import ProcessTripsIcon from '../../utils/ProcessTripsIcon';
import RegroupIcon from '../../utils/RegroupIcon';
import SendObcMsgIcon from '../../utils/SendObcMsgIcon.jsx';
import ShowObcMsgIcon from '../../utils/ShowObcMsgIcon';
import SplitTrailerIcon from '../../utils/SplitTrailerIcon';
import SplitupIcon from '../../utils/SplitupIcon';
import TableColumnIcon from '../../utils/TableColumnIcon';
import TableRowIcon from '../../utils/TableRowIcon';
import TruckAppointmentAddIcon from '../../utils/TruckAppointmentAddIcon';
import TruckAppointmentIcon from '../../utils/TruckAppointmentIcon';
import TruckAppointmentOverviewIcon from '../../utils/TruckAppointmentOverviewIcon';
import ViewEcmrIcon from '../../utils/ViewEcmrIcon';
import PartialTripDelIcon from './../../utils/PartialTripDelIcon';
import RemoveResourceIcon from './../../utils/RemoveResource';
import RemoveAllResourceIcon from '../../utils/RemoveAllResourceIcon';

let service = getSetDataService();

const ToggleMenuForConfig = ({ gridFlagVal, gridSelectedDataAction, gridSelectedPlanAction, gridSelectedCustomAction, toggleDraggedItem, gridMenuItems, griddefDataRelatedAction, gridPlanMenuItems,  gridCustomActionMenuItems, componentName, onCheckboxChange, onSelectedItemsChange, onDroppedItemsChange, onCheckboxChangePlan, onCheckboxChangeCustomAction }) => {
  const menuItems = [
    { icon: <FilterAltIcon sx={{ color: 'primary' }} />, title: 'Filter', shortkey: 'Alt+Y' },
    { icon: <TableRowIcon sx={{ color: 'primary' }} />, title: 'Table Rows', shortkey: '' },
    { icon: <TableColumnIcon sx={{ color: 'primary' }} />, title: 'View Columns', shortkey: '' },
    { icon: <SettingsSuggestIcon sx={{ color: 'primary' }} />, title: 'Settings', shortkey: '' },
    { icon: <RefreshIcon sx={{ color: 'primary' }} />, title: 'Refresh', shortkey: 'Alt+F5' },
    { icon: <SplitScreen sx={{ color: 'primary' }} />, title: 'Split Screen', shortkey: '' },
    { icon: <OpenWithIcon sx={{ color: 'primary' }} />, title: 'New Window', shortkey: '' },
    { icon: <RestoreFromTrashIcon sx={{ color: 'primary' }} />, title: 'Delete', shortkey: '' },
    { icon: <GroupsIcon sx={{ color: 'primary' }} />, title: 'Regroup', shortkey: '' },
  ];

  const menuItemsForPlan = [
    { icon: <OutboxOutlinedIcon sx={{ color: 'primary' }} />, title: 'Send To OBC', shortkey: 'Alt+S' },
    { icon: <ModeOfTravelIcon />, title: 'Plan On New Trip', shortkey: 'Alt+P' },
    { icon: <PendingActionsIcon />, title: 'Contract Out', shortkey: 'Alt+C' },
    { icon: <ProcessTripsIcon sx={{ color: 'primary' }} />, title: 'Process Trips', shortkey: '' },
    { icon: <DepotIcon sx={{ color: 'primary' }} />, title: 'Depot', shortkey: 'Alt+I' },
    { icon: <DepotDelIcon sx={{ color: 'primary' }} />, title: 'Delete Depot', shortkey: 'Alt+O' },
    { icon: <InsertActionIcon />, title: 'Insert Begin - End Action', shortkey: '' },
    { icon: <ShareLocationIcon />, title: 'Plan On Map', shortkey: 'Ctrl+M' },
    { icon: <FactCheckOutlinedIcon />, title: 'Report', shortkey: 'Alt+R' },
    { icon: <TransferGoodsIcon />, title: 'Transfer Goods', shortkey: '' },
    { icon: <SplitTripIcon />, title: 'Split Trip', shortkey: '' },
    { icon: <GroupsOutlinedIcon sx={{ color: 'primary' }} />, title: 'Regroup', shortkey: '' },
    { icon: <DeleteTripIcon />, title: 'Delete Trip', shortkey: 'Alt+Del' },
    { icon: <HookoffIcon sx={{ color: 'primary' }} />, title: 'Hook Off', shortkey: 'Alt+H' },
    { icon: <HookoffDelIcon sx={{ color: 'primary' }} />, title: 'Delete Hook Off', shortkey: 'Alt+K' },
    { icon: <CustomHookoffIcon sx={{ color: 'primary' }} />, title: 'Custom Hook Off', shortkey: 'Alt + J' },
    { icon: <SplitupIcon sx={{ color: 'primary' }} />, title: 'Split Up', shortkey: '' },
    { icon: <RegroupIcon sx={{ color: 'primary' }} />, title: 'Regroup Movement', shortkey: '' },
    { icon: <CreateBookingIcon sx={{ color: 'primary' }} />, title: 'Create Separate Bookings', shortkey: '' },
    { icon: <CreateExistingBookingIcon sx={{ color: 'primary' }} />, title: 'Create/Add Existing Bookings', shortkey: '' },
    { icon: <ViewEcmrIcon sx={{ color: 'primary' }} />, title: 'View E-CMR', shortkey: '' },
    { icon: <CreateEcmrIcon sx={{ color: 'primary' }} />, title: 'Create E-CMR', shortkey: '' },
    { icon: <PrintCmrIcon sx={{ color: 'primary' }} />, title: 'Print CMR', shortkey: '' },
    { icon: <BlockIcon sx={{ color: 'primary' }} />, title: 'On Hold On/Off', shortkey: '' },
    { icon: <TruckAppointmentOverviewIcon sx={{ color: 'primary' }} />, title: 'Truck Appointment Overview', shortkey: '' },
    { icon: <TruckAppointmentIcon sx={{ color: 'primary' }} />, title: 'Truck Appointment New', shortkey: '' },
    { icon: <TruckAppointmentAddIcon sx={{ color: 'primary' }} />, title: 'Truck Appointment Add To', shortkey: '' },
    { icon: <InsertTerminalIcon sx={{ color: 'primary' }} />, title: 'Insert Terminal', shortkey: '' },
    { icon: <DeleteTerminalIcon sx={{ color: 'primary' }} />, title: 'Delete Terminal', shortkey: '' },
    { icon: <CreateTripIcon sx={{ color: 'primary' }} />, title: 'Create Trips', shortkey: '' },
    { icon: <AccessTimeIcon sx={{ color: 'primary' }} />, title: 'Postpone', shortkey: '' },
    { icon: <ChangePlanDepartmentIcon sx={{ color: 'primary' }} />, title: 'Change Plan Department', shortkey: '' },
    { icon: <ChangePlanSubDepartmentIcon sx={{ color: 'primary' }} />, title: 'Change Plan Subdepartment', shortkey: '' },
    { icon: <MoveUpIcon sx={{ color: 'primary' }} />, title: 'Move Up', shortkey: '' },
    { icon: <MoveDownIcon />, title: 'Move Down', shortkey: '' },
    { icon: <MapIcon />, title: 'Show On Map', shortkey: 'Alt+M' },
    { icon: <ChangeRoutesIcon sx={{ color: 'primary' }} />, title: 'Change Route', shortkey: '' },
    { icon: <ChangeStatusIcon sx={{ color: 'primary' }} />, title: 'Change Status', shortkey: '' },
    { icon: <ShipmentMoveBlIcon sx={{ color: 'primary' }} />, title: 'Set Free', shortkey: '' },
    { icon: <CalculatorIcon sx={{ color: 'primary' }} />, title: 'Calculate', shortkey: 'Alt+F7' },
    { icon: <BatchTripCreationIcon sx={{ color: 'primary' }} />, title: 'Batch Trip Creation', shortkey: '' },
    { icon: <ExchangeTrailerIcon sx={{ color: 'primary' }} />, title: 'Exchange Trailer', shortkey: '' },
    { icon: <NewTrailerIcon sx={{ color: 'primary' }} />, title: 'New Partial Trip', shortkey: '' },
    { icon: <SplitTrailerIcon sx={{ color: 'primary' }} />, title: 'Split Trailer', shortkey: '' },
    { icon: <PrintTripSheetIcon sx={{ color: 'primary' }} />, title: 'Print Trip Sheet', shortkey: '' },
    { icon: <MoveLuIcon sx={{ color: 'primary' }} />, title: 'Move To LU', shortkey: '' },
    { icon: <InsertShippinglineIcon sx={{ color: 'primary' }} />, title: 'Insert Shipping Line', shortkey: '' },
    { icon: <ChangesStatusTripIcon sx={{ color: 'primary' }} />, title: 'Changes Status', shortkey: 'Shift+F9' },
    { icon: <InsertExtraActionIcon sx={{ color: 'primary' }} />, title: 'Insert Extra Action', shortkey: '' },
    { icon: <EmailTripIcon sx={{ color: 'primary' }} />, title: 'E-mail Trip Sheet', shortkey: '' },
    { icon: <PrintOutsourceConfirmationIcon sx={{ color: 'primary' }} />, title: 'Print Outsource Confirmation', shortkey: '' },
    { icon: <EmailConfirmationIcon sx={{ color: 'primary' }} />, title: 'E-mail Outsource Confirmation', shortkey: '' },
    { icon: <PartialTripIcon sx={{ color: 'primary' }} />, title: 'Partial Trip Card', shortkey: '' },
    { icon: <DrillDownTripIcon sx={{ color: 'primary' }} />, title: 'Trip Card', shortkey: '' },
    { icon: <LocalShippingIcon sx={{ color: 'primary' }} />, title: 'Shipment Card', shortkey: '' },
    { icon: <ManageAccountsIcon sx={{ color: 'primary' }} />, title: 'All Resources', shortkey: '' },
    { icon: <DescriptionIcon sx={{ color: 'primary' }} />, title: 'File Card', shortkey: '' },
    { icon: <ShowObcMsgIcon sx={{ color: 'primary' }} />, title: 'Show OBC Messages', shortkey: '' },
    { icon: <CardResourcesIcon sx={{ color: 'primary' }} />, title: 'Show Resource Card', shortkey: '' },
    { icon: <FourCornerIcon sx={{ color: 'primary' }} />, title: 'Fixed', shortkey: 'Alt+F' },
    { icon: <SendObcMsgIcon sx={{ color: 'primary' }} />, title: 'Send Message to OBC', shortkey: '' },
    { icon: <ManualModeIcon sx={{ color: 'primary' }} />, title: 'Manual Mode', shortkey: 'Alt+M' },
    { icon: <ChangeCircleOutlinedIcon sx={{ color: 'primary' }} />, title: 'Change Sequence', shortkey: '' },
    { icon: <DeleteTripIcon sx={{ color: 'primary' }} />, title: 'Delete Partial Trip', shortkey: 'Alt+Del' },
    { icon: <RemoveResourceIcon sx={{ color: 'primary' }} />, title: 'Remove From Current Resource', shortkey: '' },
    // { icon: <RemoveAllResourceIcon sx={{ color: 'primary' }} />, title: 'Remove From All Resources', shortkey: '' }
  ]

  const [droppedItems, setDroppedItems] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);
  const [planFilteredMenuItems, setPlanFilteredMenuItems] = useState([]);
  const initialSavedCheckboxes = service.initialSavedCheckboxes;
  const savedCheckboxes = gridSelectedDataAction !== null && gridSelectedDataAction !== undefined ? gridSelectedDataAction : [];
  let storedCheckboxes = savedCheckboxes[0] ? savedCheckboxes[0] : savedCheckboxes;
  const savedCheckboxesPlan = gridSelectedPlanAction !== null && gridSelectedPlanAction !== undefined ? gridSelectedPlanAction : [];
  let storedCheckboxesPlan = savedCheckboxesPlan[0] ? savedCheckboxesPlan[0] : savedCheckboxesPlan;
  const savedCheckboxesCustomAction = gridSelectedCustomAction || [];
  let storedCheckboxesCustomAction = savedCheckboxesCustomAction[0] ? savedCheckboxesCustomAction[0] : savedCheckboxesCustomAction;
  let storedDroppedItems = toggleDraggedItem || [];

  const [checkboxArr, setCheckboxArr] = useState([]);
  const [checkboxes, setCheckboxes] = useState(() => {
    return menuItems.reduce((state, item) => {
      state[item.title] = storedCheckboxes[item.title] || false;
      return state;
    }, {});
  });

  const [checkboxPlanArr, setCheckboxPlanArr] = useState([]);
  const [checkboxesPlan, setCheckboxesPlan] = useState(() => {
    return menuItemsForPlan.reduce((state, item) => {
      state[item.title] = storedCheckboxesPlan[item.title] || false;
      return state;
    }, {});
  });

  const [checkboxActionArr, setCheckboxActionArr] = useState([]);
  const [checkboxesCustomAction, setCheckboxesCustomAction] = useState(() => {
    return gridCustomActionMenuItems?.reduce((state, item) => {
      state[item.title] = storedCheckboxesCustomAction[item.title] || false;
      return state;
    }, {});
  });

  useEffect(() => {
    if (filteredMenuItems.length == 0) {
      setFilteredMenuItems(menuItems.filter((item) => gridMenuItems.includes(item.title)));
    }
    if (planFilteredMenuItems.length == 0) {
      setPlanFilteredMenuItems(menuItemsForPlan.filter((item) => gridPlanMenuItems?.includes(item.title)));
    }
  }, []);

  useEffect(() => {
    let updatedCheckboxPlan = initialSavedCheckboxes;
    setCheckboxPlanArr((prevArray) => {
      let updatedArr = [];
      if (prevArray) {
        updatedArr = [checkboxesPlan];
      } else {
        updatedArr = [...prevArray, checkboxesPlan];
      }
      updatedCheckboxPlan[gridFlagVal] = updatedArr;
      return updatedArr;
    });
  }, [checkboxesPlan]);


  useEffect(() => {
    let updatedCheckbox = initialSavedCheckboxes;
    setCheckboxArr((prevArray) => {
      let updatedArr = [];
      if (prevArray) {
        updatedArr = [checkboxes];
      } else {
        updatedArr = [...prevArray, checkboxes];
      }
      updatedCheckbox[gridFlagVal] = updatedArr;
      return updatedArr;
    });
  }, [checkboxes]);

  useEffect(() => {
    let updatedCheckbox = initialSavedCheckboxes;
    setCheckboxActionArr((prevArray) => {
      let updatedArr = [];
      if (prevArray) {
        updatedArr = [checkboxesCustomAction];
      } else {
        updatedArr = [...prevArray, checkboxesCustomAction];
      }
      updatedCheckbox[gridFlagVal] = updatedArr;
      return updatedArr;
    });
  }, [checkboxesCustomAction])

  const DataActionShow = (event, title) => {
    const isChecked = event.target.checked;
    setCheckboxes((prevState) => ({
      ...prevState,
      [title]: isChecked,
    }));
    onCheckboxChange({ ...checkboxes, [title]: isChecked });
  };

  const DataActionShowPlan = (event, title) => {
    const isChecked = event.target.checked;
    setCheckboxesPlan((prevState) => ({
      ...prevState,
      [title]: isChecked,
    }));
    onCheckboxChangePlan({ ...checkboxesPlan, [title]: isChecked });
  };

  const CustomActionShow = (event, title) => {
    const isChecked = event.target.checked;
    setCheckboxesCustomAction((prevState) => ({
      ...prevState,
      [title]: isChecked,
    }));
    onCheckboxChangeCustomAction({ ...checkboxesCustomAction, [title]: isChecked });
  };

  useEffect(() => {
    setDroppedItems(storedDroppedItems);
  }, []);

  const onDragStart = (event, item, source, isFromDropContext = false) => {
    const { title } = item;
    const draggableData = { title, source };
    event.dataTransfer.setData('text/plain', JSON.stringify(draggableData));
    if (isFromDropContext) {
      event.dataTransfer.setData('isFromDropContext', JSON.stringify({ isFromDropContext: true }));
    }
    setDraggedItem(draggableData);
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const onDrop = (event) => {
    if (draggedItem) {
      const droppedItemData = JSON.parse(event.dataTransfer.getData('text/plain'));
      let isFromDropContext = false;
      if (event.dataTransfer.getData('isFromDropContext')) {
        isFromDropContext = JSON.parse(event.dataTransfer.getData('isFromDropContext')).isFromDropContext;
      }
      const newDroppedItemTitle = droppedItemData.title;
      const dropItemTitleList = droppedItems?.map(x => x.title);
      const dropIndex = calculateDropIndex(event.clientY);
      // Check if the item already exists in droppedItems
      if (!dropItemTitleList.includes(newDroppedItemTitle)) {
        updateDropItems(dropIndex, droppedItemData, newDroppedItemTitle);
      } else if (dropItemTitleList.includes(newDroppedItemTitle) && isFromDropContext) {
        updateDropItems(dropIndex, droppedItemData, newDroppedItemTitle, isFromDropContext);
      }
      setDraggedItem(null);
    }
  };

  const calculateDropIndex = (dropY) => {
    const itemElements = document.querySelectorAll('.dropped-items');
    let dropIndex = droppedItems.length;
    itemElements.forEach((itemElement, index) => {
      const { top, bottom } = itemElement.getBoundingClientRect();
      if (dropY >= top && dropY <= bottom) {
        dropIndex = index;
      }
    });
    return dropIndex;
  };

  const updateDropItems = (dropIndex, droppedItemData, newDroppedItemTitle, isFromDropContext = false) => {
    let newDroppedItems = [...droppedItems];
    if (isFromDropContext) {
      newDroppedItems = newDroppedItems.filter(item => item.title !== newDroppedItemTitle);
    }
    newDroppedItems.splice(dropIndex, 0, droppedItemData);
    setDroppedItems(newDroppedItems);
    onDroppedItemsChange(newDroppedItems);
  }

  const removeDroppedItem = (itemTitle) => {
    let updatedDropItems = storedDroppedItems;
    if (updatedDropItems) {
      const filteredDroppedItems = updatedDropItems?.filter((item) => item.title !== itemTitle);
      setDroppedItems(filteredDroppedItems);
      onDroppedItemsChange(filteredDroppedItems);
    }
  };

  return (
      <Box variant="elevation" className="noselect" elevation={10} width={270} sx={{ flexGrow: 1, p: 2, backgroundColor: 'info.light', marginBottom: 0, height: '100%', overflow: 'auto' }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', }} color="primary" gutterBottom>
          Plan Related Actions
        </Typography>
        <List  className="noselect">
          {planFilteredMenuItems.map((item, index) => (
            <ListItem className="noselect"  sx={{ px: .5 }} key={index} button draggable onDragStart={(e) => onDragStart(e, item, "planRelatedAction")}>
              <ListItemIcon className="noselect" sx={{ color: 'primary.main', minWidth: '30px', my: 0, pointerEvents: 'none' }}>{item.icon}</ListItemIcon>
              <ListItemText className="noselect" primary={item.title} sx={{}} />

              <ListItemText className="noselect" primary={item.shortkey} sx={{ alignItems: 'right', textAlign: 'right' }} />
              <Checkbox sx={{ m: 0, p: 0, ml: .5, }} color="secondary"

                checked={checkboxesPlan[item.title]}
                onChange={(event) => DataActionShowPlan(event, item.title)}
              />
            </ListItem>
          ))}
        </List>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', }} color="primary" gutterBottom>
            Data Related Actions
          </Typography>
        </Box>
        <List>
          {filteredMenuItems.map((item, index) => (
            <ListItem sx={{ px: .5 }} key={index} button draggable onDragStart={(e) => onDragStart(e, item, "dataRelatedAction")}>
              <ListItemIcon sx={{ color: 'primary.main', minWidth: '30px', my: 0 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.title} sx={{}} />

              <ListItemText primary={item.shortkey} sx={{ alignItems: 'right', textAlign: 'right' }} />
              <Checkbox sx={{ m: 0, p: 0, ml: .5, }} color="secondary"

                checked={checkboxes[item.title]}
                onChange={(event) => DataActionShow(event, item.title)}
              />
            </ListItem>
          ))}
        </List>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', }} color="primary" gutterBottom>
            Custom Actions
          </Typography>
        </Box> 
        <List>
          {gridCustomActionMenuItems?.map((item, index) => (
            <ListItem sx={{ px: .5 }} key={index} button draggable onDragStart={(e) => onDragStart(e, item, "customAction")}>
              <ListItemIcon sx={{ color: 'primary.main', minWidth: '30px', my: 0 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.title} sx={{}} />

              <ListItemText primary={item.shortkey} sx={{ alignItems: 'right', textAlign: 'right' }} />
              <Checkbox sx={{ m: 0, p: 0, ml: .5, }} color="secondary"

                checked={checkboxesCustomAction[item.title]}
                onChange={(event) => CustomActionShow(event, item.title)}
              />
            </ListItem>
          ))}
        </List>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
            border: '1px dashed rgba(0, 0, 0, 0.3)',
            borderRadius: '4px',
            minHeight: '100px',
            marginTop: '16px',
          }}
          onDragOver={onDragOver}
          onDrop={onDrop}
        >
          <Typography variant="body2" sx={{ fontWeight: 'bold', mb: '8px', textAlign: 'center', color: '#3b66b0' }}>
            Drop here to add function in right click
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: .3, alignItems: 'center', flexWrap: 'wrap' }}>
            {droppedItems.map((item, index) => (
              <Stack key={index} className="dropped-items" sx={{ display: 'inline-flex', flexDirection: 'row', alignItems: 'center', mb: '4px' }} borderRadius={2} border={1} borderColor={'darkgray'} draggable onDragStart={(e) => onDragStart(e, item, item.source, true)}>
                <Typography variant="body2" sx={{ flex: 1, pl: .7, }}>
                  {item.title}
                </Typography>
                <IconButton sx={{ py: 0, }}
                  onClick={() => removeDroppedItem(item.title)}
                  size="small"
                >
                  <CloseIcon sx={{ fontSize: '1.2rem', color: '' }} />
                </IconButton>
              </Stack>
            ))}
          </Box>
        </Box>
      </Box>
  )
};

export default ToggleMenuForConfig;